import api, { apiSetup } from '../api';

apiSetup(undefined);

export class ThemesService {
  BASE_URL = '/themes/';

  get() {
    return api.get<any>(this.BASE_URL);
  }
}
